import React from 'react';
import { Tooltip } from 'antd';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { getStoredThemeMode, setStoredThemeMode, ThemeMode } from '@/utils/themeMode';
import styles from './index.less';

const ThemeModeToggle: React.FC<{ className?: string }> = ({ className }) => {
    const [mode, setMode] = React.useState<ThemeMode>(() => getStoredThemeMode());

    React.useEffect(() => {
        const onStorage = (event: StorageEvent) => {
            if (event.key === 'uppac-theme-mode' && (event.newValue === 'light' || event.newValue === 'dark')) {
                setMode(event.newValue);
            }
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    const isDark = mode === 'dark';

    return (
        <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
            <button
                type="button"
                className={`${styles.themeToggle} ${className || ''}`}
                aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
                onClick={() => {
                    const nextMode = isDark ? 'light' : 'dark';
                    setMode(nextMode);
                    setStoredThemeMode(nextMode);
                }}
            >
                {isDark ? <SunOutlined /> : <MoonOutlined />}
            </button>
        </Tooltip>
    );
};

export default ThemeModeToggle;